import { defineStore } from 'pinia'

import { resourcePath } from '@shared/plugins/api'
import { ApiTransport } from '@shared/plugins/api-transport'

import {
  IShowRtcSessionDTO,
  IUpdateVideoCallFeedbackDTO,
  ShowRtcSessionDTO,
  UpdateVideoCallFeedbackDTO,
} from '@pc/models/proto/dto/rtc-session'
import { RtcSessionRO } from '@pc/models/proto/ro/rtc-session'

export const apiTransport = new ApiTransport(resourcePath, 'pc')

export const useRtcSessionsStore = defineStore('rtc-sessions', {
  actions: {
    async updateRtcFeedback(payload: IUpdateVideoCallFeedbackDTO) {
      return await apiTransport.put(
        '/rtc_sessions/update_feedback',
        new UpdateVideoCallFeedbackDTO(payload),
        UpdateVideoCallFeedbackDTO
      )
    },
    async fetchRtcSession(payload: IShowRtcSessionDTO) {
      return await apiTransport.get(
        '/rtc_sessions',
        new ShowRtcSessionDTO(payload),
        RtcSessionRO
      )
    },
  },
})
